import { Form, Input, Select, Switch, InputNumber, DatePicker, Tag } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import { t } from '../../../i18n/i18n';
import { NodeParameterType } from '../../../constants/enums';

const { TextArea } = Input;
const { Option } = Select;

class BaseModalStrategy {
  constructor() {
    this.form = null;
    this.selectedNode = null;
    this.sandbox = null;
    this.previousNode = null;
    this.previousNodeOutputData = null;
  }

  initialize({ form, selectedNode, sandbox, previousNode, previousNodeOutputData }) {
    this.form = form;
    this.selectedNode = selectedNode;
    this.sandbox = sandbox;
    this.previousNode = previousNode;
    this.previousNodeOutputData = previousNodeOutputData;
  }

  // eslint-disable-next-line class-methods-use-this
  renderBody() {
    throw new Error('renderBody must be implemented by subclass');
  }

  // eslint-disable-next-line class-methods-use-this
  renderParameterField(parameter) {
    const commonProps = {
      placeholder: t(parameter?.description),
      size: 'middle',
    };

    switch (parameter?.type) {
      case NodeParameterType.STRING:
        return (
          <Input
            {...commonProps}
            suffix={
              parameter?.description && <InfoCircleOutlined title={t(parameter?.description)} />
            }
          />
        );

      case NodeParameterType.NUMBER:
        return <InputNumber {...commonProps} className="w-100" />;

      case NodeParameterType.BOLEAN:
        return (
          <Switch checkedChildren={t('ALKYMATION_YES')} unCheckedChildren={t('ALKYMATION_NO')} />
        );

      case NodeParameterType.SELECT:
        const selectOptions = parameter?.options || parameter?.values || [];
        return (
          <Select {...commonProps} className="w-100">
            {selectOptions?.map((option) => {
              if (typeof option === 'string') {
                return (
                  <Option key={option} value={option}>
                    {option}
                  </Option>
                );
              }
              return (
                <Option key={option?.value} value={option?.value}>
                  {option?.label}
                </Option>
              );
            })}
          </Select>
        );

      case NodeParameterType.JSON:
        return <TextArea {...commonProps} rows={4} placeholder="{ ... }" />;

      case NodeParameterType.DATE:
        return (
          <DatePicker
            {...commonProps}
            showTime
            format="DD/MM/YYYY HH:mm"
            className="w-100"
            showSecond={false}
            disabledDate={(current) => current && current < moment().startOf('day')}
          />
        );

      default:
        return <Input {...commonProps} />;
    }
  }

  renderParameterFormItems(parameters = []) {
    return parameters?.map((parameter) => (
      <Form.Item
        key={parameter?.id}
        name={parameter?.id}
        label={
          <div className="parameter-label">
            <span>{t(parameter?.name)}</span>
            {parameter?.required && (
              <Tag color="red" size="small">
                {t('ALKYMATION_REQUIRED')}
              </Tag>
            )}
          </div>
        }
        rules={[
          {
            required: parameter?.required,
            message: `${t(parameter?.name)} ${t('ALKYMATION_FIELD_REQUIRED')}`,
          },
        ]}
        help={t(parameter?.description)}
      >
        {this.renderParameterField(parameter)}
      </Form.Item>
    ));
  }
}

export default BaseModalStrategy;
